import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { Button } from "../Button";

export type CardHeaderProps = {
  children?: React.ReactNode;
  className?: string;
  showBackButton?: boolean | false;
  showLogo?: boolean | false;
  onBackButtonClick?: () => void;
  isRedirectedFromLogin?: boolean;
  contentInline?: boolean | false;
};

export function CardHeader({
  children,
  className = "",
  showBackButton = false,
  showLogo = false,
  onBackButtonClick,
  isRedirectedFromLogin = false,
  contentInline = false,
}: CardHeaderProps) {
  const navigate = useNavigate();

  const handleBackButton = () => {
    if (window.history.length > 1 && !isRedirectedFromLogin) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };
  return (
    <div
      className={`${contentInline ? "absolute" : "relative"} rounded-t-2xl bg-[#080808] px-4 pl-0 overflow-hidden ${className}`}
    >
      <div className="flex gap-5 ">
        {showBackButton && (
          <Button
            type="button"
            onClick={onBackButtonClick || handleBackButton}
            className="flex h-9 w-9 items-center justify-center rounded-full bg-[#0d0f19] mt-5 text-white hover:bg-black/80"
          >
            <FontAwesomeIcon icon={faChevronLeft} className="text-xs" />
          </Button>
        )}

        {showLogo && (
          <div className="relative">
            <div>
              <img src={"/images/logo.svg"} alt="logo" />
            </div>
          </div>
        )}
      </div>

      {children && <div className="mt-3">{children}</div>}
    </div>
  );
}
